import React from 'react'
import { CallBackOpenDialog } from '../../control/dialogAlert/withDialog'

type UseMenuDrawerProps = CallBackOpenDialog
const useMenuDrawer = (props: UseMenuDrawerProps) => {
    const { openDialog } = props
    const menu = [
        {
            id: 1,
            name: 'Button',
        },
        {
            id: 2,
            name: 'Loading',
        },
    ]

    const [openDrawer_1, setOpenDrawer_1] = React.useState(false)
    const [openDrawer_2, setOpenDrawer_2] = React.useState(false)

    const handleClickMenu_1 = (item: any) => {
        console.log('handleClickMenu_1 item', item)
        setOpenDrawer_1(!openDrawer_1)
        return item.id
    }

    const handleClickDim_1 = () => {
        setOpenDrawer_1(false)
    }

    const handleOpen_1 = () => {
        setOpenDrawer_1(true)
    }

    const handleClose_1 = () => {
        setOpenDrawer_1(false)
    }

    const handleClickMenu_2 = (item: any) => {
        if (openDialog) {
            openDialog({
                title: 'Dialog text with button close',
                content: 'fooooooooooooooo',
                displayBtnClose: true,
                afterBtnClose: () => {
                    console.log('handleClickMenu_2 item', item)
                    setOpenDrawer_2(!openDrawer_2)
                },
            })
        }
    }

    const handleClickDim_2 = () => {
        setOpenDrawer_2(false)
    }

    const handleOpen_2 = () => {
        setOpenDrawer_2(true)
    }

    const handleClose_2 = () => {
        setOpenDrawer_2(false)
    }

    return {
        menu,
        openDrawer_1,
        onClickMenu_1: handleClickMenu_1,
        onClickDim_1: handleClickDim_1,
        onClose_1: handleClose_1,
        onOpen_1: handleOpen_1,
        openDrawer_2,
        onClickMenu_2: handleClickMenu_2,
        onClickDim_2: handleClickDim_2,
        onClose_2: handleClose_2,
        onOpen_2: handleOpen_2,
    }
}

export default useMenuDrawer
